export const APP_VERSION = "appVersion";
export const DARK_THEME = "darkTheme";
export const ATOM_SIDEBAR = "atom.sideBar";
export const ATOM_SIDEBAR_MORE = "atom.sideBarMore";
export const AUTH_USER_INFO = "auth.userInfo";
